const blue = [
    require('../../images/baterflay/blue/1.PNG'),
    require('../../images/baterflay/blue/2.PNG'),
    require('../../images/baterflay/blue/3.PNG'),
];
const yellow = [
    [
        require('../../images/baterflay/yelow/pose/1.png'),
        require('../../images/baterflay/yelow/pose/2.png'),
        require('../../images/baterflay/yelow/pose/3.png')
    ],
    [
        require('../../images/baterflay/yelow/neg/1.png'),
        require('../../images/baterflay/yelow/neg/2.png'),
        require('../../images/baterflay/yelow/neg/3.png')
    ],
];


module.exports = {
    blue, yellow
}